<template>
  <BaseCommonPage>
    <GalleryTop/>
    <GalleryCategory/>
    <GalleryContents/>
  </BaseCommonPage>
</template>

<script>
//import store from "@/store"
import  GalleryTop from '../components/GalleryTop'
import  GalleryContents from '../components/GalleryContents'
import  GalleryCategory from '../components/GalleryCategory'
import BaseCommonPage from './BaseCommonPage'
import { mapState } from "vuex";
export default {
  name: 'Top',
  props: {
    id: String
  },
  components: {
    GalleryTop,GalleryContents,BaseCommonPage,GalleryCategory
  },
  computed: {
    ...mapState(["setShouldDisplayAllDesignpaper"]),
  },
  mounted: function () {
    this.$store.commit('setShouldDisplayAllDesignpaper', false)
  },
  metaInfo() {
    return {
      title: 'Epson Setup Navi',
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['0-141']}
      ],
      link: [
        { rel: 'stylesheet', href: process.env.VUE_APP_ROOT + '/assets/common/css/fun_top.css' },
        { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css' }
      ]
    }
  }
}
</script>

<style scoped>
</style>